module.exports = __webpack_public_path__ + "img/2024big11.192cb123.png";